import {EmployeeRoleLevel} from 'client';

export enum DocumentStatus {
  IN_REVIEW = 'in_review',
  COMPLETED = 'completed',

  // Editor
  DRAFT = 'draft',
  READY_FOR_REVIEW = 'ready_for_review',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
  CONTEXT = 'context',
  FRAMING = 'framing',
  DRAFT_TRACKER = 'draft_tracker',
  PLANNING_COMPLETE = 'planning_complete',
  REFRESH = 'refresh',
  RETROSPECTIVE = 'retrospective',
  // Legacy Postgres enum label still present on many rows; keep until DB backfill to PLANNING_COMPLETE
  EXECUTION = 'execution',

  // Planning
  TEMPLATE = 'template',
}

export type TopNavDocument = {
  id: string;
  title?: string | null;
  name?: string | null;
  status: DocumentStatus;
  statusOptions?: DocumentStatus[];
  created_at: string;
  owner: EmployeeRoleLevel;
};
